import Pill from '@vromo/ui/components/Pill';
import theme from '@vromo/ui/components/theme';
import React, { FC } from 'react';

const DisplayTitle: FC<{ title: string, index: number, source: number }> = ({ title, index, source }) => {
  if (!title.includes('{{') || !title.includes('}}')) return <>{title}</>;

  const regex = /\s*({{[a-z]+\.[a-z]+}})\s*/g;
  const matches = title.split(regex).filter(it => it.length > 0);
  return (
    <>
      {
        matches.map(it => {
          const string = it.trim();
          if (string.startsWith('{{') && string.endsWith('}}') && string.includes('name')) {
            return (
              <div
                key={it}
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center'
                }}>
                <Pill
                  key={`${index}.name`}
                  description={source === 0 ? 'Pickup Name' : 'Dropoff Name'}
                  color={theme.primary}
                  icon={source === 0 ? 'store-alt' : 'home'}
                  style={{ fontWeight: 'normal' }}
                />
              </div>
            );
          } else if (
            string.startsWith('{{') &&
            string.endsWith('}}') &&
            string.includes('address')
          ) {
            return (
              <div
                key={it}
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center'
                }}>
                <Pill
                  icon={source === 0 ? 'store-alt' : 'home'}
                  key={`${index}.address`}
                  description={source === 0 ? 'Pickup Address' : 'Dropoff Address'}
                  color={theme.primary}
                  style={{ fontWeight: 'normal' }}
                />
              </div>
            );
          } else {
            return it;
          }
        })
      }
    </>
  )
}

export default DisplayTitle;
